import { OffersTableColumnsTitle } from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/offersTableWrapper.enums';
import { OfferDto } from 'api/OffersApi';

export const OFFERS_SORTING_FIELD: Partial<Record<OffersTableColumnsTitle, keyof OfferDto>> = {
  [OffersTableColumnsTitle.Term]: 'term',
  [OffersTableColumnsTitle.FixedRate]: 'rate',
  [OffersTableColumnsTitle.APR]: 'apr',
  [OffersTableColumnsTitle.MonthlyPayments]: 'monthlyPayment',
};

export const OFFERS_TABLE_COLUMNS = [
  {
    title: OffersTableColumnsTitle.Term,
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.Term],
    isExist: true,
  },
  {
    title: OffersTableColumnsTitle.FixedRate,
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.FixedRate],
    isExist: true,
  },
  {
    title: OffersTableColumnsTitle.APR,
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.APR],
    isExist: true,
  },
  {
    title: OffersTableColumnsTitle.MonthlyPayments,
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.MonthlyPayments],
    isExist: true,
  },
  {
    title: OffersTableColumnsTitle.Action,
    isExist: false,
  },
];

export const MAX_MOBILE_WIDTH = 650;
